import moment from 'moment';

export default cycleEndDate => moment().isAfter(cycleEndDate);
